module.exports = __webpack_public_path__ + "static/02-5ca8af7ebcf0f23a6285bab6669ce40b.jpg";